import { USER_URL } from "../constant/api";


//seller orders fetch
// export const FetchOrdersApi = async (filter) => {
//     try {
//       const response = await USER_URL.get(`/orders/seller/orders/`);
      
//       console.log(response.data);
  
//       return response.data;
//     } catch (error) {
//       console.log("error in order feching", error);
//       throw error;
//     }
//   };

//seller orders fliter fetch
// export const FetchFilterOrdersApi = async (filter) => {
//   try {
//     const response = await USER_URL.get(`/orders/seller/filter/?status=${filter}`);
//     console.log(response.data);

//     return response.data;
//   } catch (error) {
//     console.log("error in order feching", error);
//     throw error;
//   }
// };

export const FetchOrdersApi = async (filter) => {
  try {
    // Determine the URL based on the presence of the filter
    const url = filter 
      ? `/orders/seller/filter/?status=${filter}` 
      : `/orders/seller/orders/`;

    const response = await USER_URL.get(url); 
    console.log(response.data);

    return response.data;
  } catch (error) {
    console.error("Error in order fetching:", error);
    throw error; // Re-throw the error for the caller to handle
  }
};



  //seller orders fetch
export const FetchOrderViewApi = async (orderId) => {
  try {
    const response = await USER_URL.get(`/orders/seller/orders/${orderId}/`);
    console.log("order view",response.data);

    return response.data;
  } catch (error) {
    console.log("error in order feching", error);
    throw error;
  }
};

export const OrderStatusChangeApi = async (orderId, productId, data) => {
  try {
    // const response = await USER_URL.post(`/orders/seller/change-status/`,data);
    const response = await USER_URL.post(`/orders/seller/orders/${orderId}/${productId}/`, data);

    console.log("order view",response.data);

    return response.data;
  } catch (error) {
    console.log("error in order feching", error);
    throw error;
  }
};





export const UpdateDeliveryDateApi = async (orderId, productId, data) => {
  try {
    const response = await USER_URL.post(`/orders/seller/orders/${orderId}/${productId}/`, data);
    console.log("API Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating delivery date:", error.response?.data || error.message);
    throw error;
  }
};


// Admin ````````````````````````Admin

export const FetchAdminOrdersApi = async (filter) => {
  try {
    // Determine the URL based on the presence of the filter
    const url = filter 
      ? `/orders/admin/filter/?status=${filter}` 
      : `/orders/admin/orders/`;

    const response = await USER_URL.get(url); 
    console.log(response.data);

    return response.data;
  } catch (error) {
    console.error("Error in order fetching:", error);
    throw error; // Re-throw the error for the caller to handle
  }
};


export const FetchAdminOrderViewApi = async (orderId) => {
  try {
    const response = await USER_URL.get(`/orders/admin/orders/${orderId}/`);
    console.log("order view",response.data);

    return response.data;
  } catch (error) {
    console.log("error in order feching", error);
    throw error;
  }
};

// /orders/admin/orders/

export const OrderAdminStatusChangeApi = async (orderId, productId, data) => {
  try {
    // const response = await USER_URL.post(`/orders/seller/change-status/`,data);
    const response = await USER_URL.post(`/orders/admin/orders/${orderId}/${productId}/`, data);

    console.log("order view",response.data);

    return response.data;
  } catch (error) {
    console.log("error in order confirming", error);
    throw error;
  }
};


// sub admin orders fetch

export const FetchSubAdminOrdersApi = async (filter) => {
  try {
    // Determine the URL based on the presence of the filter
    const url = filter 
      ? `/orders/subadmin/filter/?status=${filter}` 
      : `/orders/subadmin/orders/`;

    const response = await USER_URL.get(url); 
    console.log(response.data);

    return response.data;
  } catch (error) {
    console.error("Error in order fetching:", error);
    throw error; // Re-throw the error for the caller to handle
  }
};

export const FetchSubAdminOrderViewApi = async (orderId) => {
  try {
    const response = await USER_URL.get(`/orders/subadmin/orders/${orderId}/`);
    console.log("order view",response.data);

    return response.data;
  } catch (error) {
    console.log("error in order feching", error);
    throw error;
  }
};